import React from 'react';
import { Stack } from '@mui/material';
import {
  getFileIconSrc,
  getFileNameAndExt,
} from '@/components/AttachmentFile/utils';
import FileViewerActions, {
  FileViewerActionsProps,
} from '@/components/FileViewer/Header/FileViewerActions';
import { Body1 } from '@/components/@IntranetLibrary/Typography';

const FileViewerHeader: React.FC<FileViewerActionsProps> = (props) => {
  const { fileName, isMobile } = props;
  const iconSrcName = getFileIconSrc(fileName);
  const { name, ext } = getFileNameAndExt(fileName);

  return (
    <Stack
      flexDirection="row"
      sx={{
        justifyContent: 'space-between',
        padding: isMobile ? '14px 16px' : '8px 24px 8px 16px',
        borderBottom: '1px solid #1F2327',
        backgroundColor: '#111315',
        gap: '12px',
        alignItems: 'center',
      }}
    >
      <Stack
        flexDirection="row"
        sx={{
          alignItems: 'center',
          gap: '8px',
          overflow: 'hidden',
          padding: '6px 0',
        }}
      >
        <img
          srcSet={`${iconSrcName}.png, ${iconSrcName}@2x.png 2x, ${iconSrcName}@3x.png 3x`}
          src={`${iconSrcName}.png`}
          alt={`${fileName} icon`}
          style={{
            width: isMobile ? '28px' : '36px',
            height: isMobile ? '28px' : '36px',
            flexShrink: 0,
          }}
        />
        <Body1
          sx={{
            fontWeight: 400,
            color: '#FFFFFF',
          }}
          className={'ellipsis'}
        >
          <span>{name}</span>
          <span>{ext}</span>
        </Body1>
      </Stack>

      {/* 우측: 액션 버튼들 */}
      <FileViewerActions {...props} />
    </Stack>
  );
};

export default FileViewerHeader;
